import React, { useRef } from 'react';
import { Button, MenuItem, Link } from '@mui/material';
import HoverMenu from 'material-ui-popup-state/HoverMenu';
import {
  usePopupState,
  bindFocus,
  bindHover,
  bindMenu,
} from 'material-ui-popup-state/hooks';

export interface PopoverMenuItemProps {
  title: string;
  href: string;
  submenuItems?: SubmenuItemProps[];
}

export interface SubmenuItemProps {
  title: string;
  href: string;
}

export function PopoverMenuItem(props: PopoverMenuItemProps) {
  const { title, href, submenuItems } = props;

  const firstSubEntryRef = useRef<HTMLLIElement>(null);
  const parentEntryRef = useRef<HTMLButtonElement>(null);

  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'desktopMenu',
  });

  const handleKeyDownOnParent = (e: React.KeyboardEvent) => {
    if (e.code === 'ArrowDown') {
      e.preventDefault(); // don't scroll down the page
      // Go into the submenu and focus the first item
      if (submenuItems && submenuItems.length > 0) {
        popupState.open();
        firstSubEntryRef.current?.focus();
      }
    }
  };

  const handleKeyDownOnSubmenu = (e: React.KeyboardEvent) => {
    if (e.code === 'Escape') {
      // refocus the parent item
      parentEntryRef.current?.focus();
    }
  };

  return (
    <>
      <Button
        variant="text"
        color="inherit"
        sx={{
          textTransform: 'uppercase',
          fontSize: 'small',
          letterSpacing: 0,
          color: '#000',
          fontWeight: 400,
        }}
        {...bindHover(popupState)}
        {...bindFocus(popupState)}
        LinkComponent={Link}
        href={href}
        onKeyDown={handleKeyDownOnParent}
        ref={parentEntryRef}
      >
        {title}
      </Button>
      {submenuItems && (
        <HoverMenu
          {...bindMenu(popupState)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        >
          {submenuItems?.map((submenuItem, index) => (
            // @ts-expect-error
            <MenuItem
              key={submenuItem.title}
              onClick={popupState.close}
              ref={index === 0 ? firstSubEntryRef : null}
              onKeyDown={handleKeyDownOnSubmenu}
              component={Link}
              href={submenuItem.href}
              sx={{
                textTransform: 'uppercase',
                fontSize: 'small',
                letterSpacing: 0,
                color: '#000',
              }}
            >
              {submenuItem.title}
            </MenuItem>
          ))}
        </HoverMenu>
      )}
    </>
  );
}
